// stretchDayWiseMetrics
export const StretchDayWiseMetrics = {
  otsLitAvg: 7923390,
  dailyData: [
    {
      cumulativeReach: 100,
      cumulativeFrequency: 1,
      deviceCount: 100,
      uniqueDeviceCount: 100,
      avgFrequency: 5,
      totalUniqueDevices: 100,
    },
    {
      cumulativeReach: 500,
      cumulativeFrequency: 5,
      deviceCount: 150,
      uniqueDeviceCount: 50,
      avgFrequency: 10,
      totalUniqueDevices: 150,
    },
    {
      cumulativeReach: 1000,
      cumulativeFrequency: 10,
      deviceCount: 350,
      uniqueDeviceCount: 200,
      avgFrequency: 15,
      totalUniqueDevices: 350,
    },
    {
      cumulativeReach: 1500,
      cumulativeFrequency: 15,
      deviceCount: 600,
      uniqueDeviceCount: 250,
      avgFrequency: 20,
      totalUniqueDevices: 600,
    },
    {
      cumulativeReach: 2000,
      cumulativeFrequency: 20,
      deviceCount: 1000,
      uniqueDeviceCount: 400,
      avgFrequency: 25,
      totalUniqueDevices: 1000,
    },
  ],
};
